

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {Prop} from "vue-property-decorator";
  import {ILocker2} from "@/model/Locker/lockerInterfaces";
  import {IOnOffHandlers} from "bonomo";
  import {ILockerCompany} from "@/model/LockerCompany/lockerCompanyInterface";
  import {namespace} from "vuex-class";
  import {EPermissionActions} from "@/model/EPermissionActions";
  import SimpleConfirmationDialog from "@/components/shared/SimpleConfirmationDialog.vue";
  import {BetterSelectItem} from "@/model/betterVuetifyInterfaces";
  import {UrlHelper} from "@/helpers/UrlHelper";

  const lockerCompanyModule = namespace("lockerCompanyModule");
  const locker2Module = namespace("locker2Module");

  @Component({
    components: {SimpleConfirmationDialog}
  })
  export default class LQrCode extends Vue {

    @lockerCompanyModule.Getter('lockerCompanies')
    lockerCompanies!: ILockerCompany[]

    @Prop()
    locker!: ILocker2;
    @Prop()
    disabled!: boolean;
    @Prop()
    editing!: boolean;
    @Prop()
    loading!: boolean;

    submitting: boolean = false;
    subscribes: IOnOffHandlers = {};
    preset: string = '0';
    utmSource: string = '';
    utmMedium: string = 'QR';
    utmCampaign: string = '';
      
    @locker2Module.Action('setFeature')
    private setFeature!: (params: { lockerId: number, data: object }) => Promise<any>;

    get canEdit(): boolean {
      return this.$canAction(EPermissionActions.ACTION_LOCKERS_UPDATE);
    }

    get registerLandingQrStatus(): boolean {
       return !!this.locker.show_register_landing_qr_code;
    }

    set registerLandingQrStatus(newVal: boolean) {
      if (this.locker.show_register_landing_qr_code === newVal) {
        return;
      }
      this.locker.show_register_landing_qr_code = newVal;
      this.setFeature({
        lockerId: this.locker.id,
        data: {show_register_landing_qr_code: this.locker.show_register_landing_qr_code},
      });
    }

    get items(): any[] {
      const items = this.$t('lockers.locker.qr.utm');
      const ret: BetterSelectItem[] = [
        {text: '-', value: {}}
      ];
      Object.keys(items).forEach(each => {
        // @ts-ignore
        const eachItem: any = items[each];
        ret.push({text: eachItem.title, value: each, disabled: true});
        Object.keys(eachItem.sources).forEach(eachSource => {
          ret.push({
            text: eachSource,
            value: {
              source: eachSource,
              campaign: each,
            },
          });
        })
      });
      return ret;
    }

    get qrSize(): number {
      const breakpoint = this.$vuetify.breakpoint;
      if (breakpoint.xl) {
        return 250;
      }
      else if (breakpoint.lgAndUp) {
        return 200;
      }
      else if (breakpoint.mdAndUp) {
        return 150;
      }
      return 250;
    }

    get qrUrl(): string {
      const paramBag = [];
      

      if (this.utmSource) {
        paramBag.push('utm_source=' + encodeURI(this.utmSource));
      }
      if (this.utmMedium) {
        paramBag.push('utm_medium=' + encodeURI(this.utmMedium));
      }
      if (this.utmCampaign) {
        paramBag.push('utm_campaign=' + encodeURI(this.utmCampaign));
      }
      const params = paramBag.length > 0
        ? '?' + paramBag.join('&')
        : '';
      return UrlHelper.lockerLanding(this.locker.id) + params;

    }

    created() {
      this.subscribes = this.$ons({
        // 'backend.call.OK.locker2Loaded': this.onLockerLoaded,
      });
    }

    beforeDestroy() {
      this.$offs(this.subscribes);
    }

    onCancel() {
      this.stopEditing();
    }

    onCopyLink() {
      navigator.clipboard.writeText(this.qrUrl);
    }

    onEdit() {
      this.$emit('update:editing', true);
    }

    onPreset(newVal: any) {
      this.utmSource = newVal.source;
      this.utmCampaign = newVal.campaign;
    }

    onTogglePanel() {
      if (this.disabled && !this.editing) {
        return;
      }
      this.$emit('update:editing', !this.editing)
    }

    stopEditing() {
      this.$emit('update:editing', false);
    }

  }

